import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">

        {/* Founded by */}
        <div className="site-footer__founder">
          <span className="site-footer__label">Founded by</span>
          <a href="https://carbonlens.io" target="_blank" rel="noopener noreferrer"
             className="site-footer__cl-link" aria-label="CarbonLens GmbH">
            <img
              src="/carbonlens-logo.svg"
              alt="CarbonLens GmbH"
              className="site-footer__cl-logo"
            />
          </a>
        </div>

        {/* Copyright */}
        <div className="site-footer__copy">
          © {new Date().getFullYear()} CarbonLens GmbH · All rights reserved
        </div>

        {/* Powered by */}
        <div className="site-footer__powered">
          <span className="site-footer__label">Powered by</span>
          <span className="site-footer__badge site-footer__badge--claude">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                 style={{ marginRight: 4, verticalAlign: 'middle' }}>
              <circle cx="12" cy="12" r="10" fill="#C97C4A"/>
              <path d="M8 16 L12 7 L16 16 M9.5 13 L14.5 13" stroke="white" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Claude · Anthropic
          </span>
          <span className="site-footer__separator">·</span>
          <span className="site-footer__badge site-footer__badge--groq">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                 style={{ marginRight: 4, verticalAlign: 'middle' }}>
              <rect width="24" height="24" rx="5" fill="#F55036"/>
              <path d="M7 17 L12 7 L17 17" stroke="white" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 13.5 L15 13.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Groq
          </span>
        </div>

      </div>
    </footer>
  );
}
